import { ChevronLeft, Upload, Languages, FileText, CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface TranslatorGuideStepProps {
  onBack: () => void;
  onComplete: () => void;
}

export function TranslatorGuideStep({ onBack, onComplete }: TranslatorGuideStepProps) {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const handleGoToMyBooks = () => {
    onComplete();
    navigate('/my-books');
  };

  const steps = [
    {
      icon: Upload,
      title: t('onboarding.translatorGuide.steps.upload.title'),
      description: t('onboarding.translatorGuide.steps.upload.description'),
    },
    {
      icon: Languages,
      title: t('onboarding.translatorGuide.steps.chooseLanguage.title'),
      description: t('onboarding.translatorGuide.steps.chooseLanguage.description'),
    },
    {
      icon: FileText,
      title: t('onboarding.translatorGuide.steps.setLevel.title'),
      description: t('onboarding.translatorGuide.steps.setLevel.description'),
    },
    {
      icon: CheckCircle,
      title: t('onboarding.translatorGuide.steps.findInLibrary.title'),
      description: t('onboarding.translatorGuide.steps.findInLibrary.description'),
    },
  ];

  return (
    <div className="translator-guide-step">
      <div className="step-header mb-8 text-center">
        <h3 className="text-2xl font-semibold text-gray-900">
          {t('onboarding.translatorGuide.title')}
        </h3>
      </div>

      <div className="guide-content max-w-2xl mx-auto">
        <div className="steps-list space-y-6 mb-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div
                key={index}
                className="guide-step flex gap-4 items-start"
              >
                <div className="step-number-icon flex-shrink-0">
                  <div className="icon-wrapper flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary">
                    <Icon className="h-6 w-6" />
                  </div>
                </div>
                <div className="step-content flex-1">
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">
                    {step.title}
                  </h4>
                  <p className="text-gray-600">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="cta-section text-center bg-gradient-to-br from-primary/5 to-primary/10 rounded-lg p-8">
          <p className="text-gray-700 mb-6 text-lg">
            {t('onboarding.translatorGuide.ctaDescription')}
          </p>
          <button
            onClick={handleGoToMyBooks}
            className="go-to-books-btn rounded-lg bg-primary px-8 py-3 text-white font-semibold hover:bg-primary/90 transition-colors shadow-md hover:shadow-lg"
          >
            {t('onboarding.translatorGuide.goToMyBooks')}
          </button>
        </div>
      </div>

      {/* Navigation */}
      <div className="navigation-buttons mt-8">
        <button
          onClick={onBack}
          className="back-btn flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-gray-700 hover:bg-gray-50 transition-colors"
        >
          <ChevronLeft className="h-4 w-4" />
          {t('common.back')}
        </button>
      </div>
    </div>
  );
}

